// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/binary/binary.proto" (package "mlmbox.client.binary", syntax proto3)
// tslint:disable
import { Binary_Position } from "../../types/account.ts";
import { Binary_BranchSelectStrategy_Request } from "../../types/account.ts";
import { Binary_View } from "../../types/account.ts";
import { PositionView_Team } from "../../types/account.ts";
import { Binary_Info } from "../../types/account.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.binary.Binary
 */
export const Binary = new ServiceType("mlmbox.client.binary.Binary", [
    { name: "Info", options: {}, I: Empty, O: Binary_Info },
    { name: "View", options: {}, I: PositionView_Team, O: Binary_View },
    { name: "SetPositionBranchSelectStrategy", options: {}, I: Binary_BranchSelectStrategy_Request, O: Binary_Position }
]);
